var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var breakpointLabels = ['xs', 'sm', 'md', 'lg', 'xl'];
// Helper function from here: https://medium.com/@_achou/dont-give-up-and-use-suppressimplicitanyindexerrors-ca6b208b9365
function keys(obj) {
    return Object.keys(obj);
}
export function getBreakpoints(prop) {
    var propValues;
    if (Array.isArray(prop)) {
        propValues = { xs: prop };
    }
    else if (typeof prop !== 'object') {
        propValues = { xs: prop };
    }
    else {
        propValues = prop;
    }
    var partialObj = __assign({}, propValues);
    var fullObj = {
        xs: partialObj.xs,
        sm: partialObj.sm,
        md: partialObj.md,
        lg: partialObj.lg,
        xl: partialObj.xl,
    };
    return fullObj;
}
export function responsiveStyles() {
    var rest = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        rest[_i] = arguments[_i];
    }
    var combined = rest;
    var breakpointValues = combined[0];
    // TODO: Move breakpoints to theme or tokens
    // Set breakpoint scale
    var breakpointWidths = {
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1920,
    };
    // Consructs style from tagged template literal
    var constructStyles = function (strings, values, breakpoint) {
        var str = '';
        strings.forEach(function (string, index) {
            var isLastString = strings.length - 1 === index;
            var value = breakpointValues[breakpoint];
            var valueArray = combined.map(function (item) { return item[breakpoint]; });
            // Interpolates responsive props into styles passed as template literal
            var modifiedValue = typeof values[index] === 'function' && !isLastString && value !== undefined
                ? values[index].apply(values, valueArray) : undefined;
            str += string + (modifiedValue || '');
        });
        return str;
    };
    return function (strings) {
        var values = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            values[_i - 1] = arguments[_i];
        }
        var styles = keys(breakpointValues).map(function (breakpoint) {
            var breakpointStyles;
            if (breakpointValues[breakpoint] !== undefined) {
                if (breakpoint === 'xs') {
                    breakpointStyles = "" + constructStyles(strings, values, breakpoint);
                }
                else {
                    breakpointStyles = "\n        @media screen and (min-width: " + breakpointWidths[breakpoint] + "px){ \n          " + constructStyles(strings, values, breakpoint) + "\n        }\n      ";
                }
            }
            return breakpointStyles;
        });
        return styles.join('') || '';
    };
}
//# sourceMappingURL=responsive-styles.js.map